(ns nextjournal.leaflet
  (:require [nextjournal.clerk.render.navbar :as navbar]
            [reagent.core :as r]))

(defn render-toc-items [items]
  (r/with-let [!expanded-at (r/atom (navbar/->toc-expanded-at items true))]
    [navbar/render-items items {:!expanded-at !expanded-at
                                :!mobile-toc? (r/atom (navbar/mobile?))
                                :expandable-toc? true}]))
